import React, { useState, useCallback } from 'react';
import {
  ProductRecognitionBBox,
  ProductRecognitionPolygon,
} from '../../../types';
import { ProductRecognitionDetectionContent } from './ProductRecognitionDetectionContent';
import { ImageItemDetailsDialog } from '../../../components/ImageItemDetailsDialog';
import { useEscapeKey } from '../../../hooks/useEscapeKey';

interface LayerItemProps {
  item: ProductRecognitionBBox | ProductRecognitionPolygon;
  cameraImageElement?: HTMLImageElement;
  layerKey?: string;
  layerBboxColor?: string;
  chainId?: number;
  storeId?: number;
}

export const LayerItem: React.FC<LayerItemProps> = ({
  item,
  cameraImageElement,
  layerKey,
  layerBboxColor,
  chainId,
  storeId,
}) => {
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);

  const closeDetailsDialog = useCallback(() => {
    setShowDetailsDialog(false);
  }, []);

  useEscapeKey(closeDetailsDialog);

  const isProductRecognitionItem = (
    item: any
  ): item is ProductRecognitionBBox | ProductRecognitionPolygon => {
    return (
      item &&
      typeof item === 'object' &&
      (('x1' in item && 'y1' in item && 'x2' in item && 'y2' in item) ||
        'points' in item)
    );
  };
  return (
    <div className="bg-gray-50 rounded p-3 text-sm">
      {/* Header with Details Button */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-medium text-gray-900">
          {item.type || 'Detection Item'}
        </h3>
        <button
          onClick={() => setShowDetailsDialog(true)}
          className="px-3 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition-colors"
        >
          Details
        </button>
      </div>

      {/* Content based on item type */}
      {isProductRecognitionItem(item) ? (
        <ProductRecognitionDetectionContent
          item={item}
          cameraImageElement={cameraImageElement}
          layerBboxColor={layerBboxColor}
          chainId={chainId}
          storeId={storeId}
        />
      ) : (
        <div className="bg-white p-4 rounded border">
          <div className="text-gray-600 text-sm mb-2">Generic Item:</div>
          <pre className="text-xs bg-gray-50 p-2 rounded overflow-x-auto">
            {JSON.stringify(item, null, 2)}
          </pre>
        </div>
      )}

      {/* Details Dialog */}
      <ImageItemDetailsDialog
        item={item}
        cameraImageElement={cameraImageElement}
        isOpen={showDetailsDialog}
        onClose={closeDetailsDialog}
        layerBboxColor={layerBboxColor}
        chainId={chainId}
        storeId={storeId}
      />
    </div>
  );
};
